import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Tabs } from './Tabs.vue'
export { default as TabsContent } from './TabsContent.vue'
export { default as TabsList } from './TabsList.vue'
export { default as TabsTrigger } from './TabsTrigger.vue'

export const tabsListVariants = cva('relative inline-flex items-center', {
  variants: {
    variant: {
      segmented: 'h-9 w-fit justify-center rounded-lg border border-border bg-muted p-[3px]',
      underline: 'w-full justify-start gap-6 border-b border-border'
    }
  },
  defaultVariants: {
    variant: 'segmented'
  }
})

export const tabsIndicatorVariants = cva(
  'pointer-events-none absolute transition-[left,width] duration-[420ms] ease-spring',
  {
    variants: {
      variant: {
        segmented:
          'top-[3px] h-[calc(100%-6px)] rounded-md border border-foreground-disabled/40 bg-background shadow-xs',
        underline: 'bottom-[-1px] h-0.5 rounded-full bg-primary'
      }
    },
    defaultVariants: {
      variant: 'segmented'
    }
  }
)

export const tabsTriggerVariants = cva(
  "relative z-[1] inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap text-sm font-medium transition-colors focus-visible:border-ring focus-visible:outline-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        segmented:
          'h-[calc(100%-1px)] flex-1 rounded-md px-2 py-1 text-muted-foreground data-[state=active]:text-foreground',
        underline: 'px-0.5 pb-2.5 text-muted-foreground data-[state=active]:text-foreground'
      }
    },
    defaultVariants: {
      variant: 'segmented'
    }
  }
)

export type TabsVariants = VariantProps<typeof tabsListVariants>
